import React from 'react';
import PropTypes from 'prop-types';
import { Range } from 'rc-slider';

import JobProfileConst from '../../../constant/JobProfileConst';

const isValueInRange = (value, low, high) => value >= low && value <= high;

const getRangeUI = (range, isShowNumber = false) => {
  const { low, high } = range;
  const { min, max } = JobProfileConst.DEFAULT_RANGE;
  const code = range.code ? range.code : range.id;

  const rangeUI = [];
  for (let i = min; i <= max; i += 1) {
    let className = '';
    if (isValueInRange(i, low, high)) {
      className += ' on';
    }

    rangeUI.push(
      <li className={className} key={`${code}-${i}`}>
        {isShowNumber && <span>{i}</span>}
      </li>,
    );
  }

  return rangeUI;
};

const trackStyle = [{ visibility: 'hidden' }];
const railStyle = { visibility: 'hidden' };
const handleStyle = [{ marginTop: '-20px' }, { marginTop: '-20px' }];

const DimensionRange = ({
  dimensionRange, hintCSRange, hintJPSRange, hintSJLRange, isEdit, onChange,
}) => {
  if (!dimensionRange) return null;

  const {
    code, displayName, low, high,
  } = dimensionRange;
  const { min, max } = JobProfileConst.DEFAULT_RANGE;
  const bound = JobProfileConst.DEFAULT_BOUND;

  const dimensionRangeUI = dimensionRange ? getRangeUI(dimensionRange, true) : null;
  const hintCSRangeUI = hintCSRange ? getRangeUI(hintCSRange) : null;
  const hintJPSRangeUI = hintJPSRange ? getRangeUI(hintJPSRange) : null;
  const hintSJLRangeUI = hintSJLRange ? getRangeUI(hintSJLRange) : null;

  return (
    <div className="ability">
      <div className="ability-label">{displayName}</div>

      <div className="ability-body">
        {dimensionRangeUI && (
          <ul className="range">
            {dimensionRangeUI}

            {isEdit && (
              <li className="range-slider">
                <Range
                  handleStyle={handleStyle}
                  trackStyle={trackStyle}
                  railStyle={railStyle}
                  step={1}
                  min={min}
                  max={max}
                  value={[low, high]}
                  allowCross={false}
                  onChange={(values) => {
                    const newLow = values[0];
                    const newHigh = values[1];
                    if (newHigh - newLow >= bound) {
                      onChange(newHigh, newLow, code);
                    }
                  }}
                />
              </li>
            )}
          </ul>
        )}

        {hintCSRangeUI && <ul className="hints hints--CS">{hintCSRangeUI}</ul>}

        {hintSJLRangeUI && <ul className="hints hints--SJL">{hintSJLRangeUI}</ul>}

        {hintJPSRangeUI && <ul className="hints hints--JPS">{hintJPSRangeUI}</ul>}
      </div>
    </div>
  );
};

DimensionRange.propTypes = {
  dimensionRange: PropTypes.objectOf(PropTypes.any).isRequired,
  hintCSRange: PropTypes.objectOf(PropTypes.any),
  hintJPSRange: PropTypes.objectOf(PropTypes.any),
  hintSJLRange: PropTypes.objectOf(PropTypes.any),
  isEdit: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

DimensionRange.defaultProps = {
  hintCSRange: null,
  hintJPSRange: null,
  hintSJLRange: null,
};

export default DimensionRange;
